import React from "react";

const Stat = ({ label, value }) => (
  <div>
    <div className="font-mono text-[11px] uppercase tracking-[0.18em] text-zinc-500">
      {label}
    </div>
    <div className="mt-1 text-2xl font-semibold text-zinc-900 tabular-nums">
      {value ?? <span className="text-zinc-300">—</span>}
    </div>
  </div>
);

const ProjectSummary = ({ estimatedDays, actualDays, estimatedCompletion }) => {
  return (
    <section>
      <span className="section-eyebrow">Summary</span>
      <div className="mt-3 grid grid-cols-1 gap-6 border-t border-zinc-200 pt-4 sm:grid-cols-3">
        <Stat label="Estimated days" value={estimatedDays} />
        <Stat label="Actual days" value={actualDays} />
        <Stat label="Est. completion" value={estimatedCompletion} />
      </div>
    </section>
  );
};

export default ProjectSummary;
